/* Prolonge les deux bras de la spirale du manege en lignes horizontales jusqu'aux bords de l'ecran,
   et y fait circuler de rares impulsions lentes et discretes aux couleurs de la spirale. */
(function () {
  function prolonger() {
    try {
      var svg = document.querySelector('.nemee-spirale');
      if (!svg || svg.getAttribute('data-ext')) return;
      var g = svg.querySelector('g');
      var defs = svg.querySelector('defs');
      if (!g || !defs) return;
      var bras = g.querySelectorAll('path');
      if (bras.length < 2) return;
      var fin = ' L8 100';
      var d = bras[0].getAttribute('d');
      if (d.slice(-fin.length) !== fin) return;
      svg.setAttribute('data-ext', '1');
      var NS = 'http://www.w3.org/2000/svg';
      var coupe = d.slice(0, -fin.length);
      var sortie = ' Q8 100 -2 100 L-340 100';
      bras[0].setAttribute('d', coupe);
      bras[1].setAttribute('d', coupe);
      bras[1].setAttribute('stroke-width', '1');
      bras[1].setAttribute('opacity', '0.55');
      svg.style.overflow = 'visible';
      var bb = bras[0].getBBox();
      var cadre = 'translate(' + bb.x + ' ' + bb.y + ') scale(' + bb.width + ' ' + bb.height + ')';

      function el(nom, attrs, parent) {
        var e = document.createElementNS(NS, nom);
        Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
        if (parent) parent.appendChild(e);
        return e;
      }

      /* Degrades de fin de ligne : meme couleur que le bras, qui s'efface vers les bords */
      function degradeFin(id, classe) {
        var lg = el('linearGradient', { id: id, gradientUnits: 'userSpaceOnUse', x1: '-2', y1: '0', x2: '-340', y2: '0' }, defs);
        el('stop', { offset: '0', 'stop-opacity': '1', 'class': classe }, lg);
        el('stop', { offset: '1', 'stop-opacity': '0.05', 'class': classe }, lg);
      }
      degradeFin('nemeeExtA', 'nemee-stop-a');
      degradeFin('nemeeExtB', 'nemee-stop-b');

      var ext = 'M9 110' + sortie;
      el('path', { d: ext, stroke: 'url(#nemeeExtA)', 'stroke-width': '1.2', opacity: '0.75' }, g);
      el('path', { d: ext, stroke: 'url(#nemeeExtB)', 'stroke-width': '1', opacity: '0.55', transform: 'rotate(180 100 100)' }, g);

      /* ---- Impulsions : une seule par bras, lentes, discretes ---- */
      var calme = window.matchMedia && (matchMedia('(max-width: 749px)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (calme || !svg.animate) return;

      function degradeLueur(id, inverse) {
        var lg = el('linearGradient', {
          id: id, gradientUnits: 'userSpaceOnUse', gradientTransform: cadre,
          x1: inverse ? '1' : '0', y1: inverse ? '1' : '0', x2: inverse ? '0' : '1', y2: inverse ? '0' : '1'
        }, defs);
        el('stop', { offset: '0%', 'class': 'nemee-stop-a' }, lg);
        el('stop', { offset: '100%', 'class': 'nemee-stop-b' }, lg);
      }
      degradeLueur('nemeeLueurA', false);
      degradeLueur('nemeeLueurB', true);

      var mg = el('linearGradient', { id: 'nemeeFondu', gradientUnits: 'userSpaceOnUse', x1: '-340', y1: '0', x2: '540', y2: '0' }, defs);
      [['0', '#000'], ['0.384', '#fff'], ['0.616', '#fff'], ['1', '#000']].forEach(function (s) {
        el('stop', { offset: s[0], 'stop-color': s[1] }, mg);
      });
      var masque = el('mask', { id: 'nemeeMasque', maskUnits: 'userSpaceOnUse', x: '-400', y: '-50', width: '1000', height: '300' }, defs);
      el('rect', { x: '-400', y: '-50', width: '1000', height: '300', fill: 'url(#nemeeFondu)' }, masque);

      var complet = coupe + sortie;
      var lueurs = el('g', { mask: 'url(#nemeeMasque)' }, g);

      var PULSES = [
        { cote: 'A', long: 20, duree: 22000, decalage: 0.00 },
        { cote: 'B', long: 20, duree: 26000, decalage: 0.55 }
      ];
      PULSES.forEach(function (p) {
        var rot = p.cote === 'B' ? { transform: 'rotate(180 100 100)' } : {};
        function ligne(attrs) {
          var base = { d: complet, pathLength: '1000', fill: 'none', 'stroke-linecap': 'round' };
          Object.keys(rot).forEach(function (k) { base[k] = rot[k]; });
          Object.keys(attrs).forEach(function (k) { base[k] = attrs[k]; });
          return el('path', base, lueurs);
        }
        var dash = p.long + ' ' + (1000 - p.long);
        var halo = ligne({ 'stroke-width': '2.6', opacity: '0.22', 'stroke-dasharray': dash });
        halo.style.stroke = 'url(#nemeeLueur' + p.cote + ')';
        var corps = ligne({ 'stroke-width': '1.3', opacity: '0.5', 'stroke-dasharray': dash });
        corps.style.stroke = 'url(#nemeeLueur' + p.cote + ')';
        var debut = -p.decalage * 1000;
        var opts = { duration: p.duree, iterations: Infinity, easing: 'linear' };
        [halo, corps].forEach(function (c) {
          c.animate([{ strokeDashoffset: debut }, { strokeDashoffset: debut - 1000 }], opts);
        });
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prolonger);
  else prolonger();
})();
